var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('div',{staticClass:"text-h6 pa-4 text-center"},[_vm._v(" 招待したいメンバーのスマートフォンでカメラやQRコードリーダーを開き、QRコードを読み取ってください。 ")]),_c('div',{staticClass:"text-center items-center"},[(_vm.invitationUrl)?_c('vue-qrcode',{staticStyle:{"margin":"auto"},attrs:{"value":_vm.invitationUrl,"options":{ width: 300 },"tag":"img"}}):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }